module.exports = __webpack_public_path__ + "img/favorites.cd5c78c4.svg";